import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';

/**
 * Side Panel Component
 *
 * A reusable right-side panel component.
 * Based on the GeospatialViewerSidebarComponent styling and structure.
 *
 * Features:
 * - Title display
 * - Close button
 * - Content projection
 */
@Component({
    selector: 'ngx-side-panel',
    templateUrl: './side-panel.component.html',
    styleUrls: ['./side-panel.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidePanelComponent {
    /** Panel title */
    @Input() title: string = '';

    /** Emits when close button is clicked */
    @Output() closed = new EventEmitter<void>();

    onClose(): void {
        this.closed.emit();
    }
}
